export class meshanimationresult {

    public Mixer !: THREE.AnimationMixer;
    public Clock !: THREE.Clock;

    constructor(mixer: THREE.AnimationMixer, clock : THREE.Clock){
        this.Mixer = mixer;
        this.Clock = clock;
    }
}
